const routes = [
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import(/* webpackChunkName: "InboxEmptyState" */ "./views/InboxEmptyState"),
  },
  {
    path: '/new/message/dialog',
    name: 'NewMessageDialogPage',
    component: () => import(/* webpackChunkName: "NewMessagePage" */ "./views/NewMessage/NewMessagePage"),
    props: route => ({
      matterUid: route.query.matterUid
    })
  },
  {
    path: '/message/dialog/:startChannel/:matterUid',
    name: 'MessageDialogPage',
    component: () => import(/* webpackChunkName: "MessageDialogPage" */ "./views/MessageDialogPage"),
    props: route => ({...route.params})
  },
  {
    path: '/followup-dialog/:matterUid',
    name: 'FollowUpDialogPage',
    component: () => import(/* webpackChunkName: "FollowUpDialogPage" */ "./views/FollowUpDialogPage/FollowUpDialogPage"),
    props: route => ({...route.params})
  }
];

export default routes;
